import { Card } from 'antd';
import React from 'react';
export const ChartCard = ({ children }) => {
    return React.createElement(Card, { className: "w-auto rounded-2xl shadow min-h-[36rem]" }, children);
};
